<div [cxFocus]="focusConfig" (esc)="close('Escape clicked')" class="cx-modal-container warning-dialog">
  <div class="cx-modal-content">
    <div class="modal-header cx-dialog-header">
      <button (click)="close('close dialog')" [attr.aria-label]="'common.close' | cxTranslate"
        class="warning-dialog-close close" type="button">
        <img class="" src="../../../../../../../assets/icons/close_black_24.svg">
      </button>
    </div>

    <div class="cx-dialog-body modal-body">
      <ng-container *ngIf="limitedAvailability; else legacyMessage">
        <div class="cx-dialog-row limited-availability-title">
          <h3>{{ limitedAvailability.titleKey | cxTranslate }}</h3>
        </div>
        <div class="cx-dialog-row limited-availability-intro">
          <span>{{ limitedAvailability.introKey | cxTranslate }}</span>
        </div>
        <ul *ngIf="!hasRemovedItems && !hasAdjustedItems" class="cx-dialog-row limited-availability-items"
          [class.limited-availability-items-sku-grid]="!limitedAvailability.showAvailableInventory">
          <ng-container *ngFor="let item of limitedAvailability.items; trackBy: trackBySku">
            <li *ngIf="limitedAvailability.showAvailableInventory; else skuOnly"
              class="limited-availability-items-available-inventory">
              {{ 'limitedAvailability.partial.item'
              | cxTranslate : {
              sku: item.sku,
              availableInventory: item.availableInventory
              } }}
            </li>
            <ng-template #skuOnly>
              <li class="limited-availability-items-sku-only">{{ item.sku }}</li>
            </ng-template>
          </ng-container>
        </ul>
        <p *ngIf="hasRemovedItems && !hasAdjustedItems && isLimitedAvailabilityCheckout"
          class="limited-availability-intro">
          {{ 'limitedAvailability.checkoutModal.removedOnlyIntro' | cxTranslate }}
        </p>

        <div *ngIf="hasRemovedItems" class="limited-availability-section">
          <div class="limited-availability-section-removed">
            <p *ngIf="isLimitedAvailabilityCheckout || isCartUpdated" class="limited-availability-section-label">
              {{ 'limitedAvailability.checkoutModal.removedIntro' | cxTranslate }}
            </p>
            <ul class="limited-availability-column">
              <li *ngFor="let item of removedItems; trackBy: trackBySku" class="limited-availability-chip">
                {{ item.sku }}
              </li>
            </ul>
          </div>
        </div>

        <div *ngIf="hasRecommendedAlternatives" class="limited-availability-recommendations">
          <p class="limited-availability-section-label">
            {{ 'limitedAvailability.checkoutModal.recommendedAlternatives' | cxTranslate }}
          </p>
          <div class="limited-availability-recommendation-grid">
            <div *ngFor="let item of getRemovedItemsWithRecommendedAlternatives(); trackBy: trackBySku"
              class="limited-availability-recommendation-group">
              <span class="limited-availability-recommendation-source">
                {{ item.sku }}
              </span>
              <a *ngFor="let alternative of item.recommendedAlternatives; trackBy: trackByAlternativeSku"
                [attr.aria-label]="alternative.name"
                [routerLink]="{ cxRoute: 'product', params: { code: alternative.sku, name: alternative.name } } | cxUrl"
                (click)="close('redirect to alternative product')" class="limited-availability-recommendation">
                {{ alternative.sku }}
              </a>
            </div>
          </div>
        </div>

        <div *ngIf="hasAdjustedItems" class="limited-availability-section">
          <div class="limited-availability-section-adjusted">
            <p *ngIf="isLimitedAvailabilityCheckout || isCartUpdated" class="limited-availability-section-label">
              {{ 'limitedAvailability.checkoutModal.adjustedIntro' | cxTranslate }}
            </p>
            <ul class="limited-availability-column">
              <li *ngFor="let item of adjustedItems; trackBy: trackBySku" class="limited-availability-chip">
                <ng-container *ngIf="item.previousQuantity !== undefined; else availableInventory">
                  {{ item.sku }}: {{ item.previousQuantity }}
                  <img class="limited-availability-quantity-chevron" src="assets/icons/chevron-right.svg" alt="" />
                  {{ getAdjustedQuantity(item) }}
                </ng-container>
                <ng-template #availableInventory>
                  {{ 'limitedAvailability.partial.item' | cxTranslate : {
                    sku: item.sku,
                    availableInventory: item.availableInventory
                  } }}
                </ng-template>
              </li>
            </ul>
          </div>
        </div>

        <p *ngIf="(hasAdjustedItems || hasRemovedItems) && isLimitedAvailabilityCheckout"
          class="limited-availability-footer-text">
          {{ 'limitedAvailability.checkoutModal.pleaseReviewChanges' | cxTranslate }}
        </p>
        <p *ngIf="hasAdjustedItems && !hasRemovedItems && isLimitedAvailabilityCheckout"
          class="limited-availability-footer-text">
          {{ 'limitedAvailability.checkoutModal.quantityFooter' | cxTranslate }}
        </p>
        <p *ngIf="hasRemovedItems && !hasAdjustedItems && isLimitedAvailabilityCheckout"
          class="limited-availability-footer-text">
          {{ 'limitedAvailability.checkoutModal.removalFooter' | cxTranslate }}
        </p>
        <p *ngIf="isMixedChange && isLimitedAvailabilityCheckout" class="limited-availability-footer-text">
          {{ 'limitedAvailability.checkoutModal.mixedFooter' | cxTranslate }}
        </p>
        <ng-container *ngIf="!isLimitedAvailabilityCheckout">
          <div *ngFor="let footerKey of limitedAvailability.footerKeys"
            class="cx-dialog-row limited-availability-footer">
            <span *ngIf="footerKey">{{ footerKey | cxTranslate }}</span>
          </div>
        </ng-container>
      </ng-container>

      <ng-template #legacyMessage>
        <div class="cx-dialog-row">
          <span class="cx-dialog-item">{{ message }}</span>
        </div>
      </ng-template>

      <div class="cx-dialog-footer modal-footer"
        [ngClass]="{ 'limited-availability-footer': isLimitedAvailabilityCheckout && !cartEmptied }">
        <button *ngIf="!isLimitedAvailabilityCheckout" class="btn btn-primary" (click)="close('close dialog')">
          {{ 'common.ok' | cxTranslate }}
        </button>
        <ng-container *ngIf="(hasRemovedItems || hasAdjustedItems) && isLimitedAvailabilityCheckout">
          <button (click)="reviewCart()" class="btn btn-action" type="button"
            [ngClass]="{ 'btn-primary': cartEmptied, ' btn-action': !cartEmptied }">
            {{ 'limitedAvailability.checkoutModal.reviewCart' | cxTranslate }}
          </button>
          <button *ngIf="!cartEmptied" (click)="continueAndPlaceOrder()" class="btn btn-primary" type="button">
            {{ 'limitedAvailability.checkoutModal.continueAndPlaceOrder' | cxTranslate }}
          </button>
        </ng-container>
      </div>
    </div>
  </div>
</div>
